var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrolinkzLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1836 5.57584L9.07843 14.3404C8.91385 14.6918 8.56086 14.9163 8.17285 14.9163H6.9533C6.89691 14.9163 6.83804 14.9112 6.78258 14.9011C1.52156 13.9356 3.51812 8.00013 6.86857 8.02326H9.05378C9.44229 8.02326 9.79563 7.79824 9.95994 7.44619L10.4375 6.42293C10.747 5.75994 10.263 5 9.53136 5H6.86857C-0.499995 5 -2.49999 17.5 6.86857 18L9.93838 18C10.3255 18 10.6778 17.7766 10.8429 17.4264L15.0055 8.59683C15.1706 8.24668 15.5229 8.02326 15.91 8.02326H17.1573C21 8 22 14.5 17.1573 14.9163H15.0362C14.6449 14.9163 14.2896 15.1444 14.1268 15.5002L13.631 16.5839C13.3279 17.2462 13.8119 18 14.5403 18H17.1573C25.5 18 25 5 17.1573 5H14.0884C13.7003 5 13.3482 5.22446 13.1836 5.57584Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrolinkzLogo);
export default __webpack_public_path__ + "static/media/GROLINKZ_LOGO.2a4252d42dcd5a9e378dc64b02c57f27.svg";
export { ForwardRef as ReactComponent };